import { render } from "./commisionsTable.vue?vue&type=template&id=90c05a72"
import script from "./commisionsTable.vue?vue&type=script&lang=js"
export * from "./commisionsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__